import colors from 'basic-ui-lib/constants/colors';
import { IContentItem } from 'modules/channel/interfaces/api';
import styled from 'styled-components';
import { renderMedia } from '../MainZone';

interface PortraitProps {
  value?: IContentItem[]
  activeZone?: string;
  onSelectZone?: (zone: string) => void;
  border?: number;
}
const Portrait = ({ value, onSelectZone, activeZone, border }: PortraitProps) => {
  const valueZone1 = value?.find(item => item.zone === 'MAIN');

  return (
    <PortraitWrapper $border={border}>
      <Content onClick={() => onSelectZone?.('MAIN')} $active={activeZone === 'MAIN'} $border={border}>
        {renderMedia(valueZone1, border)}
      </Content>
    </PortraitWrapper>
  );
};

export default Portrait;

const PortraitWrapper = styled.div<{ $border?: number; $gap?: number }>`
  width: 100%;
  height: 100%;
  min-width: 48px;
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ $gap }) => ($gap ? `${$gap}px` : '1px')};
`;

const Content = styled.div<{ $active?: boolean, $border?: number }>`
  width: 33%;
  height: 90%;
  position: relative;
  overflow: hidden;
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  border: ${({ $active }) => ($active ? `2px solid ${colors.primary[3]}` : '2px solid transparent')};
  background-color: ${colors.neutral.text[3]};
`;
